import React, { useEffect, useState } from "react";
import { TextField, Box, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { ConfirmButton, BrandDetails } from ".";
import { WatchActions } from "../../../../state";
import { format_Word } from "../../../../lib";
import { SeriesSeo } from "./SeriesSeo";
import { CalibreDetails } from "./CalibreDetails";

export const EditWatchDetails = (props) => {
  const dispatch = useDispatch();
  const [myValue, setMyValue] = useState(props.detail);
  const [myBrand, setMyBrand] = useState();
  const [myBrandId, setMyBrandId] = useState();
  const [disabled, setDisabled] = useState(true);
  const [bgColor, setBgColor] = useState();
  const [caseBackCategory, setCaseBackCategory] = useState();
  const { brand: brandList } = useSelector(
    (state) => state.watches.watchLists,
    shallowEqual,
  );
  const siteId = useSelector((state) => state.scopes.site_id);
  const brandListTitle = brandList.map((brands) => {
    return { title: brands.brand, id: brands.brand_id };
  });
  const [attrData, setAttrData] = useState();
  const [certData, setCertData] = useState();
  const [compData, setCompData] = useState();
  const [calibreData, setCalibreData] = useState();
  const [movementTypeData, setMovementTypeData] = useState();
  const [loadingCalibre, setLoadingCalibre] = useState(false);

  const caseCategories = [
    { title: "Diameter", value: "Diameter" },
    { title: "Width & Height", value: "Width+Height" },
  ];
  const caseCategoryTitle = () => {
    const cat = attrData?.category;
    return caseCategories.find((c) => c.value === cat) || (cat ? { title: cat, value: cat } : null);
  };

  useEffect(() => {
    (async function () {
      if (props.attribute === "calibre") {
        setLoadingCalibre(true);
        const [data, cert, comp, calibre, movementTypes] = await Promise.all([
          WatchActions.getMovementDetails(props.id),
          dispatch(WatchActions.getAttribute("certification", null, siteId)),
          dispatch(WatchActions.getAttribute("calibre_complication", null, siteId)),
          WatchActions.getCalibreList(),
          WatchActions.getMovementTypeList(),
        ]);
        setAttrData(data);
        setCertData(cert);
        setCompData(comp);
        setCalibreData(calibre);
        setMovementTypeData(movementTypes);
        setLoadingCalibre(false);
      } else {
        const data = await WatchActions.getDetailsValue(
          props.attribute,
          props.id,
          props.attribute.endsWith("_group"),
          siteId,
        );
        setAttrData(data);
      }
    })();
  }, [props.attribute, props.id, siteId]);
  const myTitle = {
    title: props.brandTitle || brandListTitle.find((b) => b.id === attrData?.brand_id)?.title,
    id: attrData?.brand_id,
  };
  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      {siteId === 0 &&
        attrData &&
        !attrData.brand &&
        props.attribute !== "series" &&
        !props.attribute.endsWith("_group") &&
        props.attribute !== "calibre" && (
          <Box
            display="flex"
            justifyContent="center"
            my={2}
            p={1}
            pt={1}
            bgcolor={bgColor}
            style={{
              border: '1px solid rgba(0,0,0,0.08)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              borderRadius: 6,
            }}
          >
            <Box p={0.5}>
              <TextField
                size="small"
                multiline={true}
                style={{ width: 250 }}
                value={myValue}
                onChange={(e) => {
                  setMyValue(e.target.value);
                  setDisabled(false);
                  setBgColor("background.paper");
                  if (props.setEditName) {
                    props.setEditName(e.target.value);
                  }
                }}
                label={format_Word(props.attribute) + " Name"}
              />
            </Box>
            <Box p={0.5}>
              {attrData?.hasOwnProperty(`brand_id`) && (
                <Autocomplete
                  size="small"
                  inputValue={myBrand}
                  defaultValue={myTitle}
                  id="combo-box-demo"
                  options={brandListTitle}
                  getOptionLabel={(option) => option.title || ""}
                  onChange={(event, value) => {
                    if (value) {
                      setMyBrand(value?.title);
                      setMyBrandId(value?.id);
                      if (props.setMyBrandId) props.setMyBrandId(value?.id);
                      setDisabled(false);
                      setBgColor("background.paper");
                      if (props.setEditBrand) {
                        props.setEditBrand(value?.id);
                      }
                    }
                  }}
                  style={{ width: 200 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Brand Affiliation"
                      defaultValue={props.brandTitle}
                    />
                  )}
                />
              )}
              {props.attribute === "case_shape" && (
                <Autocomplete
                  size="small"
                  defaultValue={caseCategoryTitle()}
                  id="case-shape-category"
                  options={caseCategories}
                  getOptionLabel={(option) => option.title || ""}
                  getOptionSelected={(option, value) => option.value === value.value}
                  onChange={(event, value) => {
                    if (value) {
                      setCaseBackCategory(value);
                      setDisabled(false);
                      setBgColor("background.paper");
                    }
                  }}
                  style={{ width: 200 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Case Category"
                    />
                  )}
                />
              )}
            </Box>
            <Box p={0.5}>
              <ConfirmButton
                attribute={format_Word(props.attribute)}
                myValue={myValue}
                oldValue={props.detail}
                myBrand={myBrand}
                myBrandId={props.myBrandId ?? myBrandId ?? attrData?.brand_id}
                caseBackCategory={caseBackCategory?.value ?? caseBackCategory?.title}
                id={props.id}
                rawAttribute={props.rawAttribute}
                Add_Edit_Delete={"edit"}
                color={"primary"}
                disabled={disabled}
                path={
                  attrData?.hasOwnProperty(`brand_id`) &&
                  props.attribute !== "series_group" &&
                  props.attribute !== "series" &&
                  props.attribute !== "Series"
                    ? "watch-attribute-affiliated"
                    : props.path
                }
              />
            </Box>
            {attrData.can_delete && (
              <Box p={0.5}>
                <ConfirmButton
                  attribute={format_Word(props.attribute)}
                  myValue={myValue}
                  myBrand={myBrand}
                  myBrandId={props.myBrandId}
                  id={props.id}
                  rawAttribute={props.rawAttribute}
                  Add_Edit_Delete={"delete"}
                  color={"secondary"}
                  disabled={false}
                  path={
                    attrData?.hasOwnProperty(`brand_id`) &&
                    props.attribute !== "series_group" &&
                    props.attribute !== "series" &&
                    props.attribute !== "Series"
                      ? "watch-attribute-affiliated"
                      : props.path
                  }
                />
              </Box>
            )}
          </Box>
        )}
      {attrData && attrData.brand && <BrandDetails {...attrData} />}
      {attrData && props.attribute === "series" && (
        <SeriesSeo
          {...attrData}
          attribute={props.attribute}
          rawAttribute={props.rawAttribute}
          setGroupDetailsData={props.setGroupDetailsData}
          myTitle={myTitle}
          myBrand={myBrand}
          brandListTitle={brandListTitle}
          setMyBrand={setMyBrand}
          setMyBrandId={props.setMyBrandId}
          setEditBrand={props.setEditBrand}
          brandTitle={props.brandTitle}
          id={props.id}
          setIsDisabled={props.setIsDisabled}
          isDisabled={props.isDisabled}
          myBrandId={props.myBrandId}
        />
      )}
      {attrData && props.attribute.endsWith("_group") && (
        <SeriesSeo
          {...attrData}
          attribute={props.attribute}
          rawAttribute={props.rawAttribute}
          setGroupDetailsData={props.setGroupDetailsData}
          myTitle={myTitle}
          myBrand={myBrand}
          brandListTitle={brandListTitle}
          setMyBrand={setMyBrand}
          setMyBrandId={props.setMyBrandId}
          setEditBrand={props.setEditBrand}
          brandTitle={props.brandTitle}
          id={props.id}
          setIsDisabled={props.setIsDisabled}
          isDisabled={props.isDisabled}
          myBrandId={props.myBrandId}
        />
      )}
      {loadingCalibre && props.attribute === "calibre" && (
        <Box display="flex" justifyContent="center" alignItems="center" my={4} style={{ minHeight: 120 }}>
          <CircularProgress />
        </Box>
      )}
      {attrData && props.attribute === "calibre" && compData && calibreData && (
        <CalibreDetails
          {...attrData}
          certificationList={certData}
          complicationsList={compData}
          calibreList={calibreData}
          movementTypeList={movementTypeData || []}
          defaultCert={attrData.item_certifications || []}
          defaultCalibre={calibreData?.filter(
            (listItem) => listItem.calibre_id === attrData.parent_calibre_id,
          )}
          attribute={props.attribute}
          rawAttribute={props.rawAttribute}
          myTitle={myTitle}
          myBrand={myBrand}
          brandListTitle={brandListTitle}
          setMyBrand={setMyBrand}
          setMyBrandId={props.setMyBrandId}
          setEditBrand={props.setEditBrand}
          brandTitle={props.brandTitle}
          id={props.id}
          setIsDisabled={props.setIsDisabled}
          isDisabled={props.isDisabled}
          myBrandId={props.myBrandId}
        />
      )}
    </div>
  );
};
